import React, {useEffect, useState} from 'react';
import Step1 from '../../components/Register/Step1';
import Step2 from '../../components/Register/Step2';
import Step3 from '../../components/Register/Step3';
import {logEvent} from "../../utils/analytics";
import * as fbq from '../../utils/FacebookPixel';
import StickyYoutubePlayer from '../../components/StickyYoutubePlayer';
import {trackRegistration} from '../../components/Register/registrationRequest';


const App: React.FC = () => {
    const [step, setStep] = useState(1);
    const [schoolData, setSchoolData] = useState<any>({})
    const [teacherData, setTeacherData] = useState<any>({})

    const nextStep = () => {
        trackRegistration(() => fbq.event('OnboardingStep', {
            content_name: 'Onboarding Progress',
            content_category: 'Registration',
            step_number: step + 1
        }));
        setStep((prevStep) => prevStep + 1);
    };

    useEffect(() => {
        trackRegistration(() => {
            logEvent('Onboarding', 'Register ', 'Start');
            fbq.event('OnboardingStep', {
                content_name: 'Onboarding Start',
                content_category: 'Registration',
                step_number: 0
            });
        });
    }, []);

    const prevStep = () => {
        setStep((prevStep) => prevStep - 1);
    };

    const handleSchoolDataParent = (data: any) => {
        setSchoolData(data);
    }

    const handleTeacherDataParent = (data: any) => {
        setTeacherData(data);
    }

    const renderStep = () => {
        switch (step) {
            case 1:
                return <Step1 handleSchoolData={handleSchoolDataParent} nextStep={nextStep} />;
             case 2:
                 return <Step2 handleTeacherData={handleTeacherDataParent} nextStep={nextStep} prevStep={prevStep} />;
             case 3:
                 return <Step3 schoolData={schoolData.data} teacherData={teacherData} prevStep={prevStep} />;
            default:
                return null;
        }
    };

    return (
        <div id="register">
            <div className="steps">
                <span className={step >= 1 ? 'active' : ''}>1</span>
                <span className={step >= 2 ? 'active' : ''}>2</span>
                <span className={step >= 3 ? 'active' : ''}>3</span>
            </div>
            <div className='stepForms'>
                {renderStep()}
            </div>

            <StickyYoutubePlayer videoId="6qPNBMBP-oE" time={"0"} />
        </div>
    );
};

export default App;
